import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Loadingspin from "./loadingspin";
import { BrowserRouter } from "react-router-dom";

const Fallback = () => {
  return (
    <center><Loadingspin /></center>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<Fallback />}>
  <BrowserRouter>
      <App />
  </BrowserRouter>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
